<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="标题：" prop="title">
                <span>{{model.title}}</span>
            </el-form-item>
            <el-form-item label="开始时间：" prop="start_time">
                <span>{{model.start_time}}</span>
            </el-form-item>
            <el-form-item label="结束时间：" prop="end_time">
                <span>{{model.end_time}}</span>
            </el-form-item>
            <el-form-item label="状态：" prop="state">
                <span>{{model.state}}</span>
            </el-form-item>
            <el-form-item label="奖品一名称：" prop="goods_name1">
                <span>{{model.goods_name1}}</span>
            </el-form-item>
            <el-form-item label="奖品一图片：" prop="goods_img1">
                <span>{{model.goods_img1}}</span>
            </el-form-item>
            <el-form-item label="奖品一链接：" prop="goods_link1">
                <span>{{model.goods_link1}}</span>
            </el-form-item>
            <el-form-item label="奖品二名称：" prop="goods_name2">
                <span>{{model.goods_name2}}</span>
            </el-form-item>
            <el-form-item label="奖品二图片：" prop="goods_img2">
                <span>{{model.goods_img2}}</span>
            </el-form-item>
            <el-form-item label="奖品二链接：" prop="goods_link2">
                <span>{{model.goods_link2}}</span>
            </el-form-item>
            <el-form-item label="奖品二邀请好友人数：" prop="invite_count2">
                <span>{{model.invite_count2}}</span>
            </el-form-item>
            <el-form-item label="奖品三名称：" prop="goods_name3">
                <span>{{model.goods_name3}}</span>
            </el-form-item>
            <el-form-item label="奖品三图片：" prop="goods_img3">
                <span>{{model.goods_img3}}</span>
            </el-form-item>
            <el-form-item label="奖品三链接：" prop="goods_link3">
                <span>{{model.goods_link3}}</span>
            </el-form-item>
            <el-form-item label="奖品三邀请好友人数：" prop="invite_count3">
                <span>{{model.invite_count3}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'raffleInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                title: '',
                start_time: '',
                end_time: '',
                state: '',
                goods_name1: '',
                goods_img1: '',
                goods_link1: '',
                goods_name2: '',
                goods_img2: '',
                goods_link2: '',
                invite_count2: '',
                goods_name3: '',
                goods_img3: '',
                goods_link3: '',
                invite_count3: '',
                winning_member_ids: '',
                addtime: '',
                creator: '',
            },
            getObj:{
                url:'/api/admin/raffle/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>